module.exports = __webpack_public_path__ + "static/media/teaching.7e2791ee.svg";